export const API_HOST = 'https://api.iextrading.com/1.0';



// WEBPACK FOOTER //
// ./src/config.js